import {CrudModel} from '@ngx-ivengi/crud';
import {User} from '../user/user.model';

export class Assignment extends CrudModel {

  public date: Date = new Date();
  public name: string;
  public reference: string;
  public status: string;
  public type: string;
  public manufacturer: string;
  public projectManagerId: string;
  public mechanicId: string;
  public projectManager: User;
  public mechanic: User;
  public numbering: string;
  public fileRecording: FileList;
  public fileRecordingId: string;
  public fileRecordingSrc: string;
  public fileRecordingName: string;
  public fileWorksheet: FileList;
  public fileWorksheetId: string;
  public fileWorksheetSrc: string;
  public fileWorksheetName: string;
  public roomFrom: boolean = false;
  public roomTo: boolean = false;
  public pictureBefore: boolean = false;
  public pictureAfter: boolean = false;
  public remarks: string;
  public channelCount: number;
  public profitRiskPercentage: number = 8;
  public registrationPercentage: number = 5;
  public wastePercentage: number = 1;

  public setDate(date: Date | string): Assignment {
    if(date instanceof Date) {
      this.date = date;
    } else if(typeof date === 'string') {
      const matches = date.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/);
      if(matches) {
        const dateObj = new Date();
        dateObj.setFullYear(parseInt(matches[1], 10));
        dateObj.setMonth((parseInt(matches[2], 10) - 1));
        dateObj.setDate(parseInt(matches[3], 10));
        this.date = dateObj;
      }
    }
    return this;
  }

  public setName(name: string): Assignment {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setReference(reference: string): Assignment {
    if(typeof reference === 'string') {
      this.reference = reference;
    }
    return this;
  }

  public setStatus(status: string): Assignment {
    if(typeof status === 'string') {
      this.status = status;
    }
    return this;
  }

  public setType(type: string): Assignment {
    if(typeof type === 'string') {
      this.type = type.toUpperCase();
    }
    return this;
  }

  public setManufacturer(manufacturer: string): Assignment {
    if(typeof manufacturer === 'string') {
      this.manufacturer = manufacturer;
    }
    return this;
  }

  public setProjectManagerId(projectManagerId: string): Assignment {
    if(typeof projectManagerId === 'string') {
      this.projectManagerId = projectManagerId;
    }
    return this;
  }

  public setMechanicId(mechanicId: string): Assignment {
    if(typeof mechanicId === 'string') {
      this.mechanicId = mechanicId;
    }
    return this;
  }

  public setProjectManager(projectManager: User): Assignment {
    if(projectManager instanceof User) {
      this.projectManager = projectManager;
    }
    return this;
  }

  public setMechanic(mechanic: User): Assignment {
    if(mechanic instanceof User) {
      this.mechanic = mechanic;
    }
    return this;
  }

  public setNumbering(numberingType: string): Assignment {
    if(typeof numberingType === 'string') {
      this.numbering = numberingType;
    }
    return this;
  }

  public setFileRecording(files: FileList): Assignment {
    if(files instanceof FileList) {
      this.fileRecording = files;
    }
    return this;
  }

  public setFileRecordingId(id: string): Assignment {
    if(typeof id === 'string') {
      this.fileRecordingId = id;
    }
    return this;
  }

  public setFileRecordingSrc(src: string): Assignment {
    if(typeof src === 'string') {
      this.fileRecordingSrc = src;
    }
    return this;
  }

  public setFileRecordingName(name: string): Assignment {
    if(typeof name === 'string') {
      this.fileRecordingName = name;
    }
    return this;
  }

  public setFileWorksheet(files: FileList): Assignment {
    if(files instanceof FileList) {
      this.fileWorksheet = files;
    }
    return this;
  }

  public setFileWorksheetId(id: string): Assignment {
    if(typeof id === 'string') {
      this.fileWorksheetId = id;
    }
    return this;
  }

  public setFileWorksheetSrc(src: string): Assignment {
    if(typeof src === 'string') {
      this.fileWorksheetSrc = src;
    }
    return this;
  }

  public setFileWorksheetName(name: string): Assignment {
    if(typeof name === 'string') {
      this.fileWorksheetName = name;
    }
    return this;
  }

  public setRoomFrom(roomFrom: boolean): Assignment {
    if(typeof roomFrom === 'boolean') {
      this.roomFrom = roomFrom;
    }
    return this;
  }

  public setRoomTo(roomTo: boolean): Assignment {
    if(typeof roomTo === 'boolean') {
      this.roomTo = roomTo;
    }
    return this;
  }

  public setPictureBefore(pictureBefore: boolean): Assignment {
    if(typeof pictureBefore === 'boolean') {
      this.pictureBefore = pictureBefore;
    }
    return this;
  }

  public setPictureAfter(pictureAfter: boolean): Assignment {
    if(typeof pictureAfter === 'boolean') {
      this.pictureAfter = pictureAfter;
    }
    return this;
  }

  public setRemarks(remarks: string): Assignment {
    if(typeof remarks === 'string') {
      this.remarks = remarks;
    }
    return this;
  }

  public setChannelCount(channelCount: number): Assignment {
    if(typeof channelCount === 'number') {
      this.channelCount = channelCount;
    }
    return this;
  }

  public setProfitRiskPercentage(profitRiskPercentage: number): Assignment {
    if(typeof profitRiskPercentage === 'number') {
      this.profitRiskPercentage = profitRiskPercentage;
    }
    return this;
  }

  public setRegistrationPercentage(registrationPercentage: number): Assignment {
    if(typeof registrationPercentage === 'number') {
      this.registrationPercentage = registrationPercentage;
    }
    return this;
  }

  public setWastePercentage(wastePercentage: number): Assignment {
    if(typeof wastePercentage === 'number') {
      this.wastePercentage = wastePercentage;
    }
    return this;
  }

  public fromResponse(response: any): void {
    const projectManager = new User();
    const mechanic = new User();

    projectManager.fromResponse(response.projectManager);
    mechanic.fromResponse(response.mechanic);

    if(response.fileRecording) {
      this.setFileRecordingName(response.fileRecording.name);
    }

    if(response.fileWorksheet) {
      this.setFileWorksheetName(response.fileWorksheet.name);
    }

    this
      .setId(response.id)
      .setDate(response.date)
      .setName(response.name)
      .setReference(response.reference)
      .setStatus(response.status)
      .setManufacturer(response.manufacturer)
      .setType(response.type)
      .setProjectManagerId(response.projectManagerId)
      .setMechanicId(response.mechanicId)
      .setProjectManager(projectManager)
      .setMechanic(mechanic)
      .setNumbering(response.numbering)
      .setFileRecordingId(response.fileRecordingId)
      .setFileWorksheetId(response.fileWorksheetId)
      .setRoomTo(response.roomTo)
      .setRoomFrom(response.roomFrom)
      .setPictureBefore(response.pictureBefore)
      .setPictureAfter(response.pictureAfter)
      .setRemarks(response.remarks)
      .setProfitRiskPercentage(response.profitRiskPercentage)
      .setRegistrationPercentage(response.registrationPercentage)
      .setWastePercentage(response.wastePercentage);

    if(typeof response.channelCount !== 'undefined') {
      this.setChannelCount(response.channelCount);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment.model.ts